/**
 * VConsole 移动端调试工具插件
 * 仅在开发环境和测试环境中启用
 * 使用CDN方式引入，无需npm安装
 */
import Vue from 'vue'

export default () => {
    console.log('VConsole 插件加载')
    // 创建script标签，通过CDN引入VConsole
    const script = document.createElement('script')
    // 使用VConsole的CDN地址
    script.src = 'https://cdn.jsdelivr.net/npm/vconsole@latest/dist/vconsole.min.js'
    script.async = true

    // 脚本加载完成后初始化VConsole
    script.onload = () => {
        // 创建VConsole实例
        // eslint-disable-next-line no-undef
        const vConsole = new VConsole({
            defaultPlugins: ['system', 'network', 'element', 'storage'],
            maxLogNumber: 1000
            // 可以在这里添加更多配置
        })

        // 将vConsole实例挂载到Vue原型上，方便在组件中访问
        Vue.prototype.$vConsole = vConsole

        console.log('VConsole 已通过CDN加载并启用')
    }

    // 将脚本添加到文档中
    document.head.appendChild(script)
}
